import { createDropdownToggle } from "./createDropdownToggle";
import { toggleNavDropdown, openHoverDropdown, closeHoverDropdown } from "./toggleNavDropdown";

export function addDropdownToggle(menuItem) {
  const toggle = createDropdownToggle(menuItem);
  menuItem.insertBefore(
    toggle,
    menuItem.querySelector(".js-dropdown-menu")
  );

  // Listen to click events on the toggle
  toggle.addEventListener("click", dropdownToggleHandler);
  menuItem.addEventListener("mouseenter", dropdownHoverHandler);
}

function dropdownToggleHandler(e) {
  e.preventDefault();

  const toggle = e.target.closest("button");
  toggle && toggleNavDropdown(toggle);
}

function dropdownHoverHandler(e) {
  const header = document.querySelector(".js-page-header");
  const menuItem = e.target.closest(".js-nav-item-has-children");
  const toggle = menuItem.querySelector(".js-dropdown-toggle");

  toggle && openHoverDropdown(toggle);

  header.addEventListener("mouseleave", () => {
      closeHoverDropdown(toggle);
  });
}
